import { Component } from '@angular/core';

@Component({
  selector: 'app-akky-pro-banner',
  templateUrl: './akky-pro-banner.component.html',
  styleUrls: ['./akky-pro-banner.component.css'],
  host: {
    class: 'py-5 d-flex flex-column justify-content-center align-items-center text-center'
  }
})
export class AkkyProBannerComponent { }
